function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".problem1_svg__st1{fill:#ffb27d}.problem1_svg__st2{fill:#233862}.problem1_svg__st3{fill:#2b478b}.problem1_svg__st5{fill:#ee9849}.problem1_svg__st6{fill:#e58638}.problem1_svg__st8{fill:#ba4c43}.problem1_svg__st9{fill:#f1a34f}.problem1_svg__st10{fill:#ce8032}.problem1_svg__st11{fill:#e89746}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1757.51 1125.73c34.14-10.71 78.08-28.13 54.19-41.21-25.59-14.01-58.22 15.72-75.91 35.39-.92-.15-1.83-.3-2.76-.43-4.52-.65-9.11-.95-13.75-.97 33.72-54.05 71.34-126 39.3-135.15-34.52-9.86-59.25 77.63-71.46 138.91-33.73 7.32-70.02 23.69-107.82 34.6-13.36-48.59-44.12-121.05-108.56-119.45-67.67 1.68 16.82 80.33 73.74 127.47-12.72 2.06-25.58 3.05-38.53 2.45-82.75-3.85-134.59 52.25-134.59 52.25h444.41c16.69-26.46-8.59-75.25-58.26-93.86z",
  fill: "#a8d29f"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st1",
  d: "M1004.36 34.96S973.39 1.17 963.81.05c-9.57-1.13-48.99 17.76-51.25 25.21-2.25 7.45 43.36-7.45 45.9 0 2.53 7.45 5.35 12.52 18.3 13.08 12.95.56 24.22 7.88 24.22 7.88l3.38-11.26z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st2",
  d: "M1041.52 1219.58c-9.84-6.01-4.24-50.82-4.24-50.82s45.86-36.69 52.17-8.6 43.57 40.7 64.78 44.14c14.64 2.37 19.17 10.48 20.58 15.28h-133.29z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st3",
  d: "M1033.3 1191.1c-11.75-4.43-77.19-161.52-74.47-212.52.33-6.05-.86-55.68-2.72-65.97-1.45-8.01-3.4-17.34-5.74-27.69-3.58-15.76-8.04-33.91-13-53.37-13.91-54.69-31.64-119.72-43.86-171.49 21.94-49.2 50.05-92.26 75.84-106.96 18.4 2.24 36.14 5.64 49.28 8.49 10.47 6.15 18.29 11.41 24.1 15.9 2.04 10.2 5.02 27.22 7.43 49.13 1.55 14.34 2.86 30.78 3.47 48.76 4.37 127.6-17.94 266.25 38.94 492.56 1.59 6.31-41.07 30.03-59.27 23.16z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st2",
  d: "M1050.16 626.62c-9.48 47.44-32.29 148.83-112.78 204.93-13.91-54.69-31.64-119.72-43.86-171.49 21.94-49.2 50.05-92.26 75.84-106.96 18.4 2.24 36.14 5.64 49.28 8.49 10.47 6.15 18.29 11.41 24.1 15.9 2.03 10.2 5.01 27.21 7.42 49.13z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st1",
  d: "M951.19 180.29l-.04 7.96s2.17 24.89-28.48 28.52c-30.65 3.64-53.86-9.71-53.03-28.91 2.76-14.87 5.79-25.08 6-37.39.08-4.57-.24-9.42-1.09-14.9l59.38-1.19 17.49 2.86-.23 43.05z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M951.42 137.24l-.23 43.05c-6.31 2.93-13.43 4.72-21.41 4.72-27.29 0-44.93-20.01-54.15-34.54.08-4.57-.24-9.42-1.09-14.9l59.38-1.19 17.5 2.86z",
  fill: "#e8945b"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st1",
  d: "M954.88 158.16s-76.05 15.36-84.89-32.15-24.61-77.53 23.58-89.34c48.19-11.82 61.02 4.55 67.83 19.69 6.8 15.14 13.04 96.58-6.52 101.8z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st2",
  d: "M900.12 1219.58s-4.15-22.74-10.74-35.9c-6.58-13.16-48.47-4.79-48.47-4.79s-8.38 7.18-10.17 40.69h69.38z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st3",
  d: "M982.2 578.24s-41.69 185.75-55.05 269.6c-5 31.37-15.42 131.88-17.05 163.61-2.23 43.54-16.59 176.79-16.59 176.79s-24.21-15.3-60.15-1.02c0 0-9.08-59.73-14.85-184.83-1.69-36.67 5.39-91.76 4.53-109.65-4.23-87.98-32.34-315.44-9.99-330.04 22.35-14.61 169.15 15.54 169.15 15.54z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st2",
  d: "M976.18 21.06s-21.21-1.63-46.23-12.51c-20.3-8.83-45.92.89-54.23 5.27.22-1.34.76-3.17 2.03-5 0 0-3.73 2.65-4.28 6.35-.38.28-.56.48-.46.54 0 0-4.23-.77-6.95.45 0 0 1.9-.27 2.58.95.07.13.18.24.3.34-31.67 15.3-34.6 65.36-24.4 76.94 12.26 13.93 26.96 45.31 26.96 45.31s5.36-7.41 3.13-19.68c-2.23-12.26 8.36-12.26 21.74-17.84 13.38-5.57 2.23-21.18 13.93-30.66 11.71-9.48 54.62-3.9 54.07-11.15 15.94-5.78 11.81-37.68 11.81-39.31z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st5",
  d: "M996.49 18.53s-6.41 2.6-10.26 11.66c-4.92 11.59-.91 17.91-.91 17.91s80.49 73 75.26 86.29c-2.73 6.94-65.09 43.51-91.01 58.47-10.66-.89-18.9-.82-19.16-.82l-.01.01s-17.63 53.71-80.75-4.19c-11.09 16.13-97.03 55.74-82.11 124.1 3.51 16.06 6.54 31.22 9.15 45.51 17.74 96.86 16.35 154 12.89 185.51-2.69 24.59-12.89 27.07-3.77 33.61 0 0 17.75 7.96 50.96 14.84 24.69 5.11 57.91 9.66 98.73 9.92 64.93.41 89.51-21.97 89.51-21.97 17.19-16.81-16.81-82.97-14.09-130.72 1.4-24.5-.14-108.37-.38-146.91l.02-.02.05-.05c3.11-3.41 98.11-107.93 116.81-167.26 0-.01.01-.01.01-.03.94-2.99 1.69-5.86 2.22-8.61 5.69-29.21-153.16-107.25-153.16-107.25z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st6",
  d: "M809.57 542.98c3.46-31.51 4.84-88.65-12.89-185.51 1.22-3.85 2.42-7.56 3.61-11.09 5.38-15.97 28.23-15.17 32.45 1.15 13.11 50.68 24.91 136.83-23.17 195.45z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st1",
  d: "M790.19 490.03s39.48-23.87 51.71-20.84c12.24 3.02 38.78 14.56 37.14 21.62-1.64 7.05-32.48 11.87-37.85 11.04s-14.03.14-17.54 3.18c-3.52 3.03-31.49 4.17-34.91-4.03-3.42-8.19 1.45-10.97 1.45-10.97z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st5",
  d: "M869.63 187.86s-48.4 3.51-74.7 18.92c-17.01 9.97-115.61 167.07-115.61 190.19s103.54 105.15 103.54 105.15 19.22 6.38 19.9-24.22c0 0-51.65-76.35-48.93-85.19 1.71-5.55 77.83-66.62 77.83-66.62l37.97-138.23z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st6",
  d: "M1147.43 134.41c-18.7 59.33-113.69 163.84-116.81 167.26l-.05.05-.03.03s0-.01-.01-.03c-.27-1.05-8.11-30.94 10.6-52.32 19.04-21.76 84.75-76.31 106.3-114.99zM851.38 196.81c-.21-4.19 19.66-9.99 19.66-9.99s22.74 31.52 60.19 32.07c0 0-10.67 20.77-23.26 26.15.01 0-55.35-23.33-56.59-48.23zM931.23 218.15s19.84-11.76 19.91-24.52c0 0 12.81-1.6 18.41 4.61 0 0 4.71 21.86-1.54 34.55.01 0-28.56-4.35-36.78-14.64z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M1000.22 514.26a41.448 41.448 0 01-11.79 27.46l-11.33 11.59c-2.84 2.91-7.56 2.77-10.24-.29l-15.72-17.95a24.827 24.827 0 01-6.13-17.46c.64-14.24 1.78-41.67 2.46-68.13.56-21.44.82-42.25.26-54.87-1.78-40.3-16.49-168.34-16.49-168.34h9.68s26.59 48.61 42.69 115.8c3.97 16.54 7.29 34.19 9.44 52.54.01 0 8.88 73.1 7.17 119.65z",
  fill: "#c65447"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st8",
  d: "M917.76 216.26l26.91-6.45s3.51.31 3.42 4.69c-.1 4.38-7.58 17.19-10.89 18.21-3.32 1.02-25.8-7.58-19.44-16.45z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st5",
  d: "M851.38 190.68c-.21-4.19 19.66-9.99 19.66-9.99s22.74 31.52 60.19 32.07c0 0-10.67 20.77-23.26 26.15.01.01-55.35-23.32-56.59-48.23zM931.23 212.77s19.84-11.76 19.91-24.52c0 0 12.81-1.6 18.41 4.61 0 0 4.71 21.86-1.54 34.55.01 0-28.56-4.35-36.78-14.64z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st8",
  d: "M1000.22 514.26a41.448 41.448 0 01-11.79 27.46l-11.33 11.59c-2.84 2.91-7.56 2.77-10.24-.29l-15.72-17.95a24.827 24.827 0 01-6.13-17.46c.64-14.24 1.78-41.67 2.46-68.13 25.12-31.38 33.77-73.38 36.15-107.41 3.97 16.54 7.29 34.19 9.44 52.54 0 0 8.87 73.1 7.16 119.65z"
});

var _ref22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st2",
  d: "M758.16 1219.58H593.58c-8.98 0-16.32-7.34-16.32-16.32v-110.57c0-8.98 7.34-16.32 16.32-16.32h164.58c8.98 0 16.32 7.34 16.32 16.32v110.57c0 8.98-7.34 16.32-16.32 16.32z"
}), /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st3",
  d: "M759.52 1092.69v110.58c0 8.98-7.34 16.32-16.32 16.32H578.62c-8.98 0-16.32-7.34-16.32-16.32v-110.58c0-8.98 7.34-16.32 16.32-16.32H743.2c8.97-.01 16.32 7.34 16.32 16.32z"
}), /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st2",
  d: "M624.95 1076.36c10.53-12.44 24.24-17.34 33.01-17.34 21.46 0 33.44 16.7 33.89 17.34l-5.23.35c-.38-.54-8.87-11.23-27.42-11.23-7.62 0-18.8.03-27.98 10.88-.59.71-6.4.16-6.27 0zM759.52 1097.22v32.14c0 8.98-7.34 16.32-16.32 16.32H578.62c-8.98 0-16.32-7.34-16.32-16.32v-32.14c0-8.98 7.34-16.32 16.32-16.32H743.2c8.97 0 16.32 7.34 16.32 16.32z"
}), /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st3",
  d: "M759.52 1092.69v32.14c0 8.98-7.34 16.32-16.32 16.32H578.62c-8.98 0-16.32-7.34-16.32-16.32v-32.14c0-8.98 7.34-16.32 16.32-16.32H743.2c8.97-.01 16.32 7.34 16.32 16.32z"
}), /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st2",
  d: "M652.97 1128.5a4.991 4.991 0 019.98 0 4.991 4.991 0 01-9.98 0z"
}));

var _ref23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st9",
  d: "M1670.5 324.93v880.25c0 7.92-6.04 14.4-13.42 14.4h-13.42c-3.68 0-7.02-1.61-9.46-4.21-2.44-2.61-3.96-6.23-3.96-10.19V324.93c0-5.17 2.57-9.73 6.41-12.25 2.04-1.36 4.45-2.15 7.01-2.15h13.42c7.38 0 13.42 6.47 13.42 14.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st6",
  d: "M1640.6 322.87v880.25c0 5.16-2.57 9.73-6.4 12.25-2.44-2.61-3.96-6.23-3.96-10.19V324.93c0-5.17 2.57-9.73 6.41-12.25 2.43 2.6 3.95 6.21 3.95 10.19z"
}), /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st9",
  d: "M1486.85 668.45l-74.29 50.08 67.37 59.06 166.73-10.51v-67.35z"
}), /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st10",
  d: "M1635.53 708.93c-.76 2.05-.52 4.91.54 6.39 1.06 1.47 2.53 1 3.29-1.05s.52-4.91-.54-6.39c-1.06-1.48-2.53-1.01-3.29 1.05zM1635.53 748.75c-.76 2.05-.52 4.91.54 6.39 1.06 1.47 2.53 1 3.29-1.05s.52-4.91-.54-6.39c-1.06-1.47-2.53-1-3.29 1.05z"
}), /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st9",
  d: "M1916.32 532.39l116.1 49.98-111.64 59.29-267.15-9.28v-83.39z"
}), /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st11",
  d: "M1916.32 532.39h16.87l116.09 49.98h-16.86z"
}), /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st10",
  d: "M1920.78 641.66h8.99l119.51-59.29h-16.86zM1671.11 561.5c.98 2.63.67 6.3-.69 8.19s-3.25 1.29-4.22-1.34c-.98-2.63-.67-6.3.69-8.19 1.36-1.89 3.25-1.29 4.22 1.34zM1671.11 612.6c.98 2.63.67 6.3-.69 8.19s-3.25 1.29-4.22-1.34c-.98-2.63-.67-6.3.69-8.19 1.36-1.9 3.25-1.3 4.22 1.34z"
}), /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st9",
  d: "M1390.95 387.79l-116.1 49.98 111.63 59.29 267.15-9.28v-83.39z"
}), /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st11",
  d: "M1390.95 387.79h-16.87l-116.09 49.98h16.86z"
}), /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st10",
  d: "M1386.48 497.06h-8.98l-119.51-59.29h16.86zM1636.15 416.9c-.98 2.63-.67 6.3.69 8.19s3.25 1.29 4.22-1.34.67-6.3-.69-8.19c-1.35-1.89-3.24-1.29-4.22 1.34zM1636.15 468c-.98 2.63-.67 6.3.69 8.19s3.25 1.29 4.22-1.34.67-6.3-.69-8.19c-1.35-1.9-3.24-1.3-4.22 1.34z"
}), /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st11",
  d: "M1486.85 668.45h-9.62l-78.9 50.52h14.23z"
}), /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st10",
  d: "M1479.93 777.59h-12.96l-68.64-58.62h14.23z"
}), /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st9",
  d: "M1700.39 1120.24v99.34h-100.07v-99.73c0-18.51 14.05-33.72 32.06-35.58 1.22-.12 2.46-.19 3.71-.19h28.13c19.99.01 36.17 16.2 36.17 36.16z"
}), /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st6",
  d: "M1664.79 1120.24v99.34h-64.47v-99.73c0-18.51 14.05-33.72 32.06-35.58 18.22 1.88 32.41 17.28 32.41 35.97z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st6",
  d: "M1655.01 282.6v-3.47h-8.84v.06c-2.41.23-4.5 1.2-6.26 2.92-2.03 1.98-3.05 4.43-3.05 7.33 0 2.81 1.04 5.22 3.12 7.26 2.08 2.03 4.52 3.05 7.33 3.05h7.69v-3.46c1.64-1.89 2.47-4.17 2.47-6.84.01-2.68-.82-4.96-2.46-6.85zM1671.99 198.16c-6.29-5.32-14.13-7.98-23.51-7.98-6 0-11.71 1.38-17.12 4.14-5.42 2.76-9.63 6.65-12.63 11.68-1.84 3.1-2.76 6.19-2.76 9.29 0 2.42.75 4.43 2.25 6.02 1.5 1.6 3.41 2.39 5.73 2.39h7.69s-.09-2.89-.1-4.86l5.32-7.18c2.8-2.8 6.53-4.21 11.18-4.21 3.96 0 7.28 1.09 9.94 3.27 2.66 2.18 3.99 5.25 3.99 9.21 0 4.55-1.4 8.08-4.21 10.59-2.03 1.84-5.51 3.53-10.45 5.08-3.68 1.16-6.12 2.35-7.33 3.56s-1.82 3.02-1.82 5.44v14.51c0 2.9.77 5.32 2.32 7.26 1.55 1.94 3.72 2.9 6.53 2.9h7.69v-4.4c.35-.69.65-1.43.87-2.28.38-1.55.58-5.51.58-11.9 7.93-1.55 14.2-4.96 18.79-10.23 4.59-5.27 6.89-11.92 6.89-19.96.03-9.18-3.26-16.63-9.84-22.34z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "problem1_svg__st9",
  d: "M1689.55 220.51c0 8.03-2.3 14.68-6.89 19.96-4.6 5.27-10.86 8.68-18.79 10.23 0 6.39-.19 10.36-.58 11.9-1.16 4.45-4.02 6.68-8.56 6.68-2.81 0-4.98-.97-6.53-2.9s-2.32-4.35-2.32-7.26V244.6c0-2.42.6-4.23 1.82-5.44 1.21-1.21 3.65-2.39 7.33-3.56 4.93-1.55 8.42-3.24 10.45-5.08 2.81-2.51 4.21-6.04 4.21-10.59 0-3.97-1.33-7.04-3.99-9.21-2.66-2.18-5.98-3.27-9.94-3.27-4.64 0-8.37 1.4-11.18 4.21l-5.8 7.84c-2.03 2.81-4.4 4.21-7.11 4.21-2.32 0-4.23-.8-5.73-2.39-1.5-1.6-2.25-3.6-2.25-6.02 0-3.09.92-6.19 2.76-9.29 3-5.03 7.21-8.92 12.63-11.68s11.12-4.14 17.12-4.14c9.38 0 17.22 2.66 23.51 7.98 6.55 5.7 9.84 13.15 9.84 22.34zm-24.38 68.93c0 2.9-.97 5.35-2.9 7.33-1.94 1.98-4.35 2.97-7.26 2.97-2.81 0-5.25-1.02-7.33-3.05s-3.12-4.45-3.12-7.25c0-2.9 1.02-5.35 3.05-7.33 2.03-1.98 4.5-2.98 7.4-2.98s5.32.99 7.26 2.98c1.93 1.99 2.9 4.43 2.9 7.33z"
}))));

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M0 1220.2l468.16 3.06s-43.29-87.03-150.71-68.41c-67.8 11.75-90.25-5.97-118.15-23.35 51.65-19.54 128.16-51.84 92.55-59.65-33.99-7.45-80.32 25.66-108.85 50.26-5.97-3.07-12.47-5.92-19.83-8.37 61.06-57.03 175.97-170.74 125.21-173.98-49.8-3.18-112.82 109.31-142.81 169.34-3.45-.69-7.08-1.29-10.89-1.79-15.54-2.05-30.03.76-43.32 6.65-6.62-24.91-18.84-53.4-35.09-47.6-16.4 5.86 2.14 34.72 19.16 56.41C28.28 1154.1 0 1220.2 0 1220.2z",
  fill: "#82b378"
});

var SvgProblem1 = function SvgProblem1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "problem1_svg___x3C_Layer_x3E_",
    x: 0,
    y: 0,
    viewBox: "0 0 2049.28 1223.26",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
};

export default __webpack_public_path__ + "static/problem1.1b041053.svg";
export { SvgProblem1 as ReactComponent };